import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDialog } from "../features/dialog/dialogSlice";
import { downloadFileByID } from "../app/api/axios/services/files.service";

const useFileData = (initialData) => {
  const [fileData, setFileData] = useState(initialData || []);
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch initial data if needed
  }, []);

  const updateFile = (id, newData) => {
    setFileData((prevData) =>
      prevData.map((file) => (file.id === id ? { ...file, ...newData } : file))
    );
  };

  const deleteFile = (id) => {
    setFileData((prevData) => prevData.filter((file) => file.id !== id));
  };

  const handleFileAction = async (fileData, action) => {
    if (!fileData) return;

    const showDialog = (title, type, content, data) => {
      dispatch(setDialog({ title, type, content, data }));
    };

    switch (action) {
      case "CREATE-READINGCONFIRMATION":
        return showDialog(
          "Lesebestätigung erstellen",
          "CREATE",
          "create-readingconfirmation",
          { fileData, action: "CREATE" }
        );

      case "SINGLE-FILEDATA":
        return showDialog("Dokumentdaten bearbeiten", "EDIT", "filedata-edit", {
          fileData,
          action: "EDIT",
        });

      case "MULTI-FILEDATA":
        return showDialog(
          "Daten mehrerer Dokumente bearbeiten",
          "EDIT",
          "filedata-edit-multi",
          { fileData, action: "EDIT" }
        );

      case "RELEASE":
        return showDialog("Dokument freigeben", "CREATE", "file-release", {
          fileData,
          action: "SHOW",
        });

      case "DELETE":
        return showDialog("Dokument löschen", "DELETE", "file-delete", {
          fileData,
          action,
        });

      case "NACHWEIS":
        return showDialog("Nachweis erzeugen", "CREATE", "create-proof", {
          fileData,
          action,
        });

      case "ASSIGN":
        return showDialog("Dokument zuweisen", "ASSIGN", "assign-file", {
          fileData,
        });

      case "DOWNLOAD":
        try {
          const response = await downloadFileByID(fileData._id);
          const arrayBuffer = response.data;

          const blob = new Blob([arrayBuffer], {
            type: response.headers["content-type"],
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileData.fileName; // Set the desired file name

          link.click();

          window.URL.revokeObjectURL(link.href);
        } catch (error) {
          showDialog("Fehler beim Download", "ERROR", null, {
            errorText: "Die Datei konnte nicht heruntergeladen werden.",
          });
        }
        return;

      case "SHOW":
      case "REVIEW":
      case "EDIT":
      case "RECALL":
        if (fileData.isCheckedOut) {
          return showDialog(
            `${fileData.fileName} ist ausgecheckt!`,
            "ERROR",
            null,
            {
              errorText:
                "Das von Ihnen angeforderte Dokument wird bereits bearbeitet. Bitte versuchen Sie es später erneut.",
            }
          );
        }
        return showDialog("Datei anzeigen", "CREATE", "file-show", {
          fileData,
          action,
          checkOut: true,
        });

      default:
        return showDialog("Datei anzeigen", "CREATE", "file-show", {
          fileData,
          action,
        });
    }
  };

  return { fileData, updateFile, deleteFile, handleFileAction };
};

export default useFileData;
